import React from 'react';
import './styles.css';

export default function SalesForceEmailToBook() {

    const styles = {
        input: {
          display: 'inline',
          borderTop: 'medium none',
          borderLeft: 'medium none',
          borderRight: 'medium none',
          color: 'color: rgb(141, 141, 141)'
        },
        select: {
          borderTop:' medium none',
          borderLeft: 'medium none',
          borderRight: 'medium none',
          display: 'inline',
          height: '51px'
        },
        submitButton: {
          backgroundColor: 'rgb(0, 171, 235)',
          color: 'rgb(255, 255, 255)',
          border: 'medium none',
          borderRaduis: '0px',
          letterSpacing: '0.3em',
          fontSize: '12px'
        }
    };

    const convertAndFormatDate = e => {
        let input = e.target;
        const selectedDate = input.value;

        if (selectedDate)
        {
            const dateObj = new Date(selectedDate);
            const day = String(dateObj.getUTCDate()).padStart(2, '0');
            const month = String(dateObj.getUTCMonth() + 1).padStart(2, '0');
            const year = String(dateObj.getUTCFullYear());

            const formattedDate = `${year}-${month}-${day}`;
            input.type = 'text';
            input.value = formattedDate;

            // Add a class to indicate that a date is selected
            input.classList.add('has-date');
        }
    }

    const switchInputType = e => {
        let input = e.target;
        if (input.type === 'text')
        {
            input.type = 'date';
            // Remove the 'has-date' class when switching back to date input
            input.classList.remove('has-date');
            input.value = '';
        }
    }

    return (
        <form action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00D8b00000134NM" method="POST">
            <div>
                <h2 className="mb-2 mt-3 p-0 d-flex justify-content-center">Curate Your <span style={{fontStyle: 'italic', fontWeight: 400}}>Own</span>?</h2>
                
                <input 
                    type="hidden" 
                    name="oid" 
                    value="00D8b00000134NM"
                />
                <input 
                    type="hidden" 
                    name="retURL" 
                    value="https://www.islandroutes.com/thank-you-bespoke-experience"
                />
                
                <div className="row">
                    <div className="col mb-2">
                        <input 
                            placeholder="First Name" 
                            id="first_name" 
                            maxLength="40" 
                            name="first_name" 
                            size="20" 
                            type="text" 
                            className="w-100" 
                            style={styles.input}
                        />
                    </div>
                    <div className="col mb-2">
                        <input 
                            placeholder="Last Name" 
                            id="last_name" 
                            maxLength="80" 
                            name="last_name" 
                            size="20" 
                            type="text" 
                            className="w-100" 
                            style={styles.input}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col mb-2">
                        <input 
                            placeholder="Email" 
                            id="email" 
                            maxLength="80" 
                            name="email" 
                            size="20" 
                            type="text" 
                            className="w-100" 
                            style={styles.input} 
                        />
                    </div>
                    <div className="col mb-2">
                        <input 
                            placeholder="Phone" 
                            id="phone" 
                            maxLength="40" 
                            name="phone" 
                            size="20" 
                            type="text" 
                            className="w-100" 
                            style={styles.input}
                        />				
                    </div>
                </div>
                <div className="row">
                    <div className="col mb-2 form-text">
                        <span className="dateInput">
                            <div className="date-input-container">
                                <input 
                                    data-label="Date Picker 1" 
                                    placeholder="Proposed Date Of Experience" 
                                    id="00N8b00000EZCE8" 
                                    name="00N8b00000EZCE8" 
                                    size="20" 
                                    type="date" 
                                    className="w-100 custom-date-input"
                                    style={styles.input}
                                    onClick={switchInputType}
                                    onChange={convertAndFormatDate}
                                /> 
                                <label className="custom-label" forhtml="myDateInput">Proposed Date Of Experience</label>
                            </div>
                        </span>
                    </div>
                    <div className="col mb-2 form-text">
                        <input 
                            placeholder="Number of participants" 
                            id="00N8b00000EZCE6"
                            name="00N8b00000EZCE6"
                            size="20"
                            type="text"
                            className="w-100" 
                            style={styles.input}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col mb-2 form-text">
                        <select 
                            className="w-100" 
                            id="00N8b00000EZCDz" 
                            name="00N8b00000EZCDz"                    
                            title="Destination Interest"
                            style={styles.input}
                        >
                            <option value="">Destination Interest</option>
                            <option value="Antigua">Antigua</option>
                            <option value="Aruba">Aruba</option>
                            <option value="Bahamas">Bahamas</option>
                            <option value="Barbados">Barbados</option>
                            <option value="Curacao">Curacao</option>
                            <option value="Dominican Republic">Dominican Republic</option>
                            <option value="Grand Cayman">Grand Cayman</option>
                            <option value="Grenada">Grenada</option>
                            <option value="Jamaica">Jamaica</option>
                            <option value="Mexico">Mexico</option>
                            <option value="Saint Maarten">Saint Maarten</option>
                            <option value="St. Lucia">St. Lucia</option>
                            <option value="Turks & Caicos">Turks &amp; Caicos</option>
                        </select>
                    </div>
                    <div className="col mb-2 form-text">
                        <span className="dateInput">
                            <div className="date-input-container">
                                <input 
                                    data-label="Date Picker 2" 
                                    placeholder="Second Date Picker" 
                                    id="00N8b00000EZCLp" 
                                    name="00N8b00000EZCLp" 
                                    size="20" 
                                    type="date" 
                                    className="w-100 custom-date-input"
                                    style={styles.input}
                                    onClick={switchInputType}
                                    onChange={convertAndFormatDate}
                                />
                                <label className="custom-label" forhtml="second_date_picker">Travel start date</label>
                            </div>
                        </span>
                    </div>
                </div>
                <div className="row">
                    <div className="col mb-2 form-text">
                        <span className="dateInput">
                            <div className="date-input-container">
                                <input 
                                    data-label="Date Picker 3"
                                    placeholder="Third Date Picker"
                                    id="00N8b00000EZCLo"
                                    name="00N8b00000EZCLo"
                                    size="20"
                                    type="date"
                                    className="w-100 custom-date-input" 
                                    style={styles.input}
                                    onClick={switchInputType}
                                    onChange={convertAndFormatDate}
                                />
                                <label className="custom-label" forhtml="third_date_picker">Travel end date</label>
                            </div>
                        </span>
                    </div>
                    <div className="col mb-2 form-text">
                        <input 
                            placeholder="Where are you staying?"
                            id="00N8b00000EZCEK"
                            maxLength="255"
                            name="00N8b00000EZCEK" 
                            size="20"
                            type="text"
                            className="w-100"
                            style={styles.input}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col mb-2 form-text">
                        <select 
                            className="w-100"
                            id="00N8b00000EZCDr"
                            name="00N8b00000EZCDr"
                            title="Are you travelling with children?"
                            style={styles.input}
                        >
                            <option value="">Are you travelling with children?</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>
                    <div className="col mb-2 form-text">
                        <select 
                            className="w-100"
                            id="00N8b00000EZFca"
                            name="00N8b00000EZFca"
                            title="Are you a travel advisor?"
                            style={styles.input}
                        >
                            <option value="">Are you a travel advisor?</option>
                            <option value="No">No</option>
                            <option value="Yes">Yes</option>
                        </select>
                    </div>
                </div>
                <div className="row my-2">
                    <div className="col mb-2 form-text">
                        <select 
                            className="w-100"
                            id="00N8b00000EZCE0"
                            name="00N8b00000EZCE0"
                            title="Have you travelled with us before?"
                            style={styles.input}
                        >
                            <option value="">Have you travelled with us before?</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>
                    <div className="col mb-2 form-text">
                        <input 
                            placeholder="What would you like to experience?" 
                            id="00N8b00000EZCDp" 
                            maxLength="255" 
                            name="00N8b00000EZCDp" 
                            size="20" 
                            type="text" 
                            className="w-100"
                            style={styles.input}
                        />				
                    </div>
                </div>
                <div className="row my-2">
                    <div className="col mb-2 form-text">
                        <select
                            id="00N8b00000IhasC" 
                            name="00N8b00000IhasC"                    
                            title="Which curated experience would you like?" 
                            style={{
                                borderLeft: 'none',
                                borderRight: 'none',
                                borderTop: 'none'
                            }}
                        >
                            <option value="">Which curated experience would you like?</option>
                            <option value="Bamboo River Rafting &amp; Riverside Lunch - Jamaica">Bamboo River Rafting &amp; Riverside Lunch - Jamaica</option>
                            <option value="Powerboat, Secluded Cove &amp; Waterfall Experience Ocho Rios - Jamaica">Powerboat, Secluded Cove &amp; Waterfall Experience Ocho Rios - Jamaica</option>
                            <option value="Luxury Catamaran &amp; Waterfall Experience - Jamaica">Luxury Catamaran &amp; Waterfall Experience - Jamaica</option>
                            <option value="Modern Heritage Open Fire Dinner Ocho Rios - Jamaica">Modern Heritage Open Fire Dinner Ocho Rios - Jamaica</option>
                            <option value="Plant-based Al Fresco Dining Experience - Jamaica">Plant-based Al Fresco Dining Experience - Jamaica</option>
                            <option value="Artisanal Chocolate Tasting Experience - Jamaica">Artisanal Chocolate Tasting Experience - Jamaica</option>
                            <option value="Powerboat Adventure &amp; Beachside Lunch Montego Bay - Jamaica">Powerboat Adventure &amp; Beachside Lunch Montego Bay - Jamaica</option>
                            <option value="Blue Mountains Hike, Holywell &amp; Coffee Experience - Jamaica">Blue Mountains Hike, Holywell &amp; Coffee Experience - Jamaica</option>
                            <option value="Jamaican Cuisine Masterclass &amp; Wine Pairing - Jamaica">Jamaican Cuisine Masterclass &amp; Wine Pairing - Jamaica</option>
                            <option value="Luxury Catamaran Charter &amp; Waterfall Experience - Jamaica">Luxury Catamaran Charter &amp; Waterfall Experience - Jamaica</option>
                            <option value="Blue Mountains Farm To Table Dining Experience - Jamaica">Blue Mountains Farm To Table Dining Experience - Jamaica</option>
                            <option value="Interactive Chocolate Making Experience - Jamaica">Interactive Chocolate Making Experience - Jamaica</option>
                            <option value="Decadent Delights: A Curated Chocolate Experience - St. Lucia">Decadent Delights: A Curated Chocolate Experience - St. Lucia</option>
                            <option value="Gros Piton Hike &amp; Luxury Catamaran Experience- St. Lucia">Gros Piton Hike &amp; Luxury Catamaran Experience- St. Lucia</option>
                            <option value="Helicopter, Seaside Dining &amp; Luxury Catamaran Experience- St. Lucia">Helicopter, Seaside Dining &amp; Luxury Catamaran Experience- St. Lucia</option>
                            <option value="Private Sulphur Springs Serenity - St. Lucia">Private Sulphur Springs Serenity - St. Lucia</option>
                            <option value="Sulphur Springs Serenity - St Lucia">Sulphur Springs Serenity - St Lucia</option>
                            <option value="I Want To Request Something Else">I Want To Request Something Else</option>
                            {/* <option value="Bamboo River Rafting & Riverside Lunch - Jamaica">Bamboo River Rafting &amp; Riverside Lunch - Jamaica</option>
                            <option value="Powerboat, Secluded Cove & Waterfall Experience Ocho Rios - Jamaica">Powerboat, Secluded Cove &amp; Waterfall Experience Ocho Rios - Jamaica</option>
                            <option value="Luxury Catamaran & Waterfall Experience - Jamaica">Luxury Catamaran &amp; Waterfall Experience - Jamaica</option>
                            <option value="Modern Heritage Open Fire Dinner Ocho Rios - Jamaica">Modern Heritage Open Fire Dinner Ocho Rios - Jamaica</option>
                            <option value="Plant-based Al Fresco Dining Experience - Jamaica">Plant-based Al Fresco Dining Experience - Jamaica</option>
                            <option value="Artisanal Chocolate Tasting Experience - Jamaica">Artisanal Chocolate Tasting Experience - Jamaica</option>
                            <option value="Powerboat Adventure & Beachside Lunch Montego Bay - Jamaica">Powerboat Adventure &amp; Beachside Lunch Montego Bay - Jamaica</option>
                            <option value="Blue Mountains Hike, Holywell & Coffee Experience - Jamaica">Blue Mountains Hike, Holywell &amp; Coffee Experience - Jamaica</option>
                            <option value="Jamaican Cuisine Masterclass & Wine Pairing - Jamaica">Jamaican Cuisine Masterclass &amp; Wine Pairing - Jamaica</option>
                            <option value="Blue Mountains Farm To Table Dining Experience - Jamaica">Blue Mountains Farm To Table Dining Experience - Jamaica</option>
                            <option value="Summerhouse Al Fresco Dining Experience - Jamaica">Summerhouse Al Fresco Dining Experience - Jamaica</option>
                            <option value="Interactive Chocolate Making Experience - Jamaica">Interactive Chocolate Making Experience - Jamaica</option>
                            <option value="I Want To Request Something Else">I Want To Request Something Else</option> */}
                        </select>
                    </div>
                    <div className="col mb-2 form-text">
                        <input 
                            placeholder="Any custom requests?"
                            id="00N8b00000IhasM"
                            maxLength="255"
                            name="00N8b00000IhasM"
                            size="20"
                            type="text"
                            className="w-100" 
                            style={styles.input}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-6 mb-2 form-text">
                        <select 
                            className="w-100"
                            id="00N8b00000EZFck"
                            name="00N8b00000EZFck"
                            title="Subscribed"
                            style={styles.input}
                        >
                            <option value="">Subscribe to stay in touch?</option>
                            <option value="No">No</option>
                            <option value="Yes">Yes</option>
                        </select>
                    </div>
                   
                </div>
                <div className="g-recaptcha my-2" data-sitekey="6Leol70lAAAAANkis-0NyYBfrkJnQXIGPqcQFKWH">
                    <div style={{width: '304px', height: '78px'}}>
                        <div>
                            <iframe title="reCAPTCHA" src="https://www.google.com/recaptcha/api2/anchor?ar=2&k=6Leol70lAAAAANkis-0NyYBfrkJnQXIGPqcQFKWH&co=aHR0cHM6Ly93d3cuaXJlc2FuZGJveC5jb206NDQz&hl=en&v=wqcyhEwminqmAoT8QO_BkXCr&size=normal&cb=lj3rrbavdqsf" width="304" height="78" name="a-75ze64y3399v" frameBorder="0" scrolling="no" sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation allow-modals allow-popups-to-escape-sandbox"></iframe>
                        </div>
                        <textarea 
                            id="g-recaptcha-response"
                            name="g-recaptcha-response" 
                            className="g-recaptcha-response"
                            style={{
                                width: '250px',
                                height: '40px',
                                border: '1px solid rgb(193, 193, 193)',
                                margin: '10px 25px',
                                padding: '0px',
                                resize: 'none',
                                display: 'none'
                            }}
                        ></textarea>
                    </div>
                    <iframe style={{display: 'none'}}></iframe>
                </div>
                <input id="recordType" name="recordType" value="0128b0000008AOT" type="hidden" />
                <input id="IR_Campaign__c" name="IR_Campaign__c" value="Bespoke" type="hidden" />
                
                <input 
                    className="col-12 mb-3 text-uppercase"
                    type="submit"
                    name="submit"
                    style={{
                        backgroundColor: 'rgb(0, 171, 235)',
                        color: 'rgb(255, 255, 255)',
                        border: 'medium none',
                        borderRaduis: '0px',
                        letterSpacing: '0.3em',
                        fontSize: '12px' 
                    }}
                />
                
            </div>
        </form>        
    );
}


// WEBPACK FOOTER //
// ./resources/js/components/EmailToBookModal/SalesForceEmailToBook.js